import { createContext } from 'react';
import { PortalContact, PortalLookupResponse } from '../../types/portal';

export interface PortalAuthContextType {
  slug: string;
  /** Undefined while the slug is still being resolved. */
  portal: PortalLookupResponse | null | undefined;
  contact: PortalContact | null | undefined;
  isSignedIn: boolean;
  loading: boolean;
  error: string | null;
  requestCode: (email: string) => Promise<boolean>;
  signIn: (email: string, code: string) => Promise<boolean>;
  signOut: () => void;
  hasModule: (module: string) => boolean;
}

export const PortalAuthContext = createContext<PortalAuthContextType | undefined>(undefined);
